import Responsive from './Responsive';
import SmoothScroll from './SmoothScroll';
import Accordion from './Accordion';
import Tab from './Tab';
import SpNavi from './SpNavi';
import ToTop from './ToTop';
import DropDownMenu from './DropDownMenu';
import BlockLink from './BlockLink';
import Gmap from './Gmap';
import bowser from 'bowser';
import matchheight from 'jquery-match-height';
import remodal from 'remodal';


if(bowser.msie === true) {
  $('body').addClass('ie');
}else if(bowser.msedge === true){
  $('body').addClass('edge');
}else if(bowser.firefox === true){
  $('body').addClass('ff');
}else if(bowser.tablet === true){
  $('body').addClass('tablet');
}
if(bowser.mobile === true){
  $('body').addClass('device--mobile');
  if(bowser.android === true) {
    $('body').addClass('device--mobile--android');
  }
}

let os, ua = navigator.userAgent;
if (ua.match(/Win(dows )?NT 10\.0/)) {
  os = "win10";
}
else if (ua.match(/Win(dows )?NT 6\.3/)) {
  os = "win8_1";
}
else if (ua.match(/Win(dows )?NT 6\.2/)) {
  os = "win8";
}
else if (ua.match(/Win(dows )?NT 6\.1/)) {
  os = "win7";
}else{
  os = '';
}

$('body').addClass(os);
/* ===============================================
Check responsive state
=============================================== */
const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// 	console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
/*
const gnav_clone = $('.gnavi > ul').clone();
const subnav_clone = $('.sub_navi > ul > li > a').clone();
const subnav_child_clone = $('.sub_navi > ul .sub_navi-target .gnavi-child a').clone();
$('#scroller .inner')
.prepend(gnav_clone)
.append($('<div class="subnavi_wrap" />'));

$('<div class="subnavi1" />').appendTo('.subnavi_wrap');
$('<div class="subnavi2" />').appendTo('.subnavi_wrap');

subnav_clone.appendTo('#scroller .inner .subnavi1');
subnav_child_clone.appendTo('#scroller .inner .subnavi2');
$('.sp_search').appendTo('#scroller .inner');

$('.subnavi1 a').each(function(){
	if($(this).text() == '対象者別ナビ'){
		$(this).hide();
	}
})
*/
let param = {
	target:'#spnavi',
	trigger:'.btn_sp_navi',
	filter:'resposive_flg',
	speed:200,
	fixer:180
};
const spnavi = new SpNavi(param);

let spnav_accordion_1 = (scroller)=>{
	$('#scroller .inner > ul > li > span').off();
	$('#scroller .inner > ul > li > span').on('click',function(){
		let $parent = $(this).parent('li');
		let $child = $(this).next('.child');
		let status = $child.css('display');

		if(status == 'block'){
			$child.slideUp(300,function(){
				scroller.refresh();
			});
			$parent.removeClass('active');
		}else{
			$child.slideDown(300,function(){
				scroller.refresh();
			});
			$parent.addClass('active');
		}

		return false;
	});
}
$(window).on('load',function(){
	spnavi.exec(spnav_accordion_1);
});

/* ===============================================
box link
=============================================== */
let box_link = new BlockLink();
box_link.exec('.aside_footer-inner .col');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop('#totop',1000,400);
totop.exec();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
 const ac = new Accordion($('.aside_nav-child span'));
 ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
const tab = new Tab('.component-tab_ctrl > ul > li','.component-tab_ctrl .component-tab_content');
tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });
const gnavi_child = $('.gnavi .gnavi-child');

$('.gnavi > ul > li.has_child').on('mouseenter',function(){
	$(this).find('.gnavi-child').stop(true,true).fadeIn(400);
}).on('mouseleave',function(){
	$(this).find('.gnavi-child').stop(true,true).fadeOut(200);
});

(function($) {
$(function(){
	$('.component a[target="_blank"]:not(:has(img)) , .footer-nav-col a[target="_blank"]:not(:has(img))').addClass('js--link_icon');
	$('.component a[target="_new"]:not(:has(img)) , .footer-nav-col a[target="_new"]:not(:has(img))').addClass('js--link_icon');
	//Pdf
	$('.js--link_icon[href$=pdf]').addClass('js--link_icon-pdf');
	//Excel
	$('.js--link_icon[href$=xls],.js--link_icon[href$=xlsx],.js--link_icon[href$=xlsm]').addClass('js--link_icon-xls');
	//Word
	$('.js--link_icon[href$=doc],.js--link_icon[href$=docx]').addClass('js--link_icon-docx');
	//PowerPoint
	$('.js--link_icon[href$=pptx],.js--link_icon[href$=pptm],.js--link_icon[href$=ppt]').addClass('js--link_icon-pptx');
	//外部リンク
	$('.js--link_icon[href^=http]:not([href*="'+location.hostname+'"],[href$=pdf],[href$=xls],[href$=xlsx],[href$=xlsm],[href$=doc],[href$=docx],[href$=pptx],[href$=pptm],[href$=ppt])').addClass('js--link_icon-ext');

	$('.component h2').prepend('<span></span>');
	$('.component h3').prepend('<span></span>');
	$('.component h4').prepend('<span></span>');
	$('.home .headline').prepend('<span></span>');
	$('.component .component-multicol .title.bg').prepend('<span></span>');
	$('.news_list-detail li .news-date').append('<span></span>');
	$('.home .important_notice a .news-date').append('<span></span>');
	$('.component table').wrap('<div class="table_wrapper"></div>');

	$('.component iframe').each(function(){
		let src = $(this).attr('src');
		if(!src.match(/form-mailer/)){
			if(src.match(/youtube/)){
				$(this).wrap('<div class="component-movie_wrap_exp"><div class="component-movie_wrap"></div></div>');
			}else{
				$(this).wrap('<div class="component-movie_wrap_exp"><div class="component-movie_wrap mod-other"></div></div>');
			}
		}


	});
});
})(jQuery);

(function($) {
$(function(){
	const $trgger = $('.nav_dropdown-trigger');
	$(window).on('load resize',function(){
		if(!r.state()()){
			$trgger.off('mouseenter');
			$trgger.off('mouseleave');
			$trgger.off('click');
			$trgger.on('click',function(){
				if($(this).find('.child').css('display') == 'block'){
					$(this).find('.child').stop(true,true).slideUp(200);
				}else{
					$(this).find('.child').stop(true,true).slideDown(200);
				}
			});
		}else{
			$trgger.off('mouseenter');
			$trgger.off('mouseleave');
			$trgger.off('click');
			$trgger.on('mouseenter',function(){
				$(this).find('.child').stop(true,true).slideDown(200);
			}).on('mouseleave',function(){
				$(this).find('.child').stop(true,true).slideUp(200);
			});
		}
	});
});
})(jQuery);

/*
(function($) {
$(function(){
	$('.sub_navi-search').on('click',function(){
		$('.search_form').fadeIn(300);
		return false;
	});

	$('.js-form_close').on('click',function(){
		$('.search_form').fadeOut(300);
		return false;
	});

	$('li.sub_navi-target').on('mouseenter',function(){
		$(this).find('.gnavi-child').stop(true,true).fadeIn(200);
	}).on('mouseleave',function(){
		$(this).find('.gnavi-child').stop(true,true).fadeOut(200);
	}).find('> a').on('click',function(){
		return false;
	})
});
})(jQuery);
*/
(function($) {
$(function(){
	$(window).on('load resize',function(){
		$('.slide--card.mod-home,.slide--card.mod-component').each(function(){
			let mh = parseInt($(this).find('.slide--card-textarea').outerHeight(),10) + parseInt($(this).find('.slide--card-textarea').css('top'),10);
			$(this).css({
				'min-height':mh
			});
		});
	});
});
})(jQuery);

const slide_home = require('./slide_home');
slide_home();

const tab_num = require('./tab_num');
tab_num();

const slide_card = require('./slide_card');
slide_card();

const slide_card_list_hasimg = require('./slide_card_list_hasimg');
slide_card_list_hasimg();

const slide_card_list_bgimg = require('./slide_card_list_bgimg');
slide_card_list_bgimg();

const category_sort_pagenation = require('./category_sort_pagenation');
category_sort_pagenation();

const year_sort = require('./year_sort');
year_sort();

const mg_introduction = require('./mg_introduction');
mg_introduction();

const oh_timeline = require('./oh_timeline');
oh_timeline();

const youtube_bg = require('./youtube_bg');
youtube_bg();


$('.js-modal-trigger').on('click',function(){
	if(r.state()()){
		return false;
	}
});


(function($) {
$(function(){
	var ti;
	if($(window).width() < 768){
		ti = "46px";
	}else{
		ti = "27px";
	}

});
})(jQuery);



//30_お知らせ：リストの絞り込み
var searchItem = '.news_search_item';   // 絞り込む項目を選択するエリア
var listItem = '.news_list_item';       // 絞り込み対象のアイテム
var hideClass = 'is-hide';         // 絞り込み対象外の場合に付与されるclass名
var activeClass = 'is-active';     // 選択中のグループに付与されるclass名
$(function() {
    // 絞り込みを変更した時
    $(searchItem).on('click', function() {
        $(searchItem).removeClass(activeClass);
        var group = $(this).addClass(activeClass).data('group');
        search_filter(group);
    });
});
/**
 * リストの絞り込みを行う
 * @param {String} group data属性の値
 */
function search_filter(group) {
    // 非表示状態を解除
    $(listItem).removeClass(hideClass);
    // 値が空の場合はすべて表示
    if(group === '') {
        return;
    }
    // リスト内の各アイテムをチェック
    for (var i = 0; i < $(listItem).length; i++) {
        // アイテムに設定している項目を取得
        var itemData = $(listItem).eq(i).data('group');
        // 絞り込み対象かどうかを調べる
        if(itemData !== group) {
            $(listItem).eq(i).addClass(hideClass);
        }
    }
}


//00_TOP：メインビジュアル
window.addEventListener('load', function () {
   sliderStart();
});

function sliderStart() {

    const slide = document.getElementById('slide_wrapp');      //スライダー親
    const slideItem = slide.querySelectorAll('.slide_item');   //スライド要素
    const totalNum = slideItem.length - 1;                     //スライドの枚数を取得
    const FadeTime = 1000;                                     //フェードインの時間
    const IntarvalTime = 8000;                                 //クロスフェードさせるまでの間隔
    let actNum = 0;                                            //現在アクティブな番号
    let nowSlide;                                              //現在表示中のスライド
    let NextSlide;                                             //次に表示するスライド

    // スライドの1枚目をフェードイン
    slideItem[0].classList.add('show_', 'zoom_');

    // 処理を繰り返す
    setInterval(() => {
        if (actNum < totalNum) {

            let nowSlide = slideItem[actNum];
            let NextSlide = slideItem[++actNum];

            //.show_削除でフェードアウト
            nowSlide.classList.remove('show_');
            // と同時に、次のスライドがズームしながらフェードインする
            NextSlide.classList.add('show_', 'zoom_');
            //フェードアウト完了後、.zoom_削除
            setTimeout(() => {
                nowSlide.classList.remove('zoom_');
            }, FadeTime);

        } else {

            let nowSlide = slideItem[actNum];
            let NextSlide = slideItem[actNum = 0];

            //.show_削除でフェードアウト
            nowSlide.classList.remove('show_');
            // と同時に、次のスライドがズームしながらフェードインする
            NextSlide.classList.add('show_', 'zoom_');
            //フェードアウト完了後、.zoom_削除
            setTimeout(() => {
                nowSlide.classList.remove('zoom_');
            }, FadeTime);

        };
    }, IntarvalTime);

}



// WEBPACK FOOTER //
// ./dev/js/scripts/main.js